export default "__VITE_ASSET__CbkRqgAv__"